import { isDemo } from "../App";
import { axiosRequest } from "../axiosConfig";
// Import pre-cached PDF data from data.json
import preCachedData from "./data.json";

// PDF Cache Manager with fallback mechanisms
class PDFCacheManager {
  constructor() {
    this.cache = new Map();
    this.maxCacheSize = 50; // Maximum number of PDFs to cache
  }

  async readFromCache(cacheKey) {
    try {
      // 1. Check the pre-cached JSON file first using just the faxId
      const preCachedKey = cacheKey.split("_")[0];

      // console.log(preCachedKey);

      if (preCachedData && preCachedData[preCachedKey]) {
        console.log(
          "Found PDF in pre-cached JSON data using faxId:",
          preCachedKey,
        );
        const cacheEntry = preCachedData[preCachedKey];
        // Optionally, store it in our in-memory cache for faster access later
        this.cache.set(cacheKey, cacheEntry);
        return new Blob([new Uint8Array(cacheEntry.content)], {
          type: "application/pdf",
        });
      }

      // // 2. Check in-memory cache
      // if (this.cache.has(cacheKey)) {
      //   console.log("Found PDF in memory cache");
      //   const cacheEntry = this.cache.get(cacheKey);
      //   return new Blob([new Uint8Array(cacheEntry.content)], {
      //     type: "application/pdf",
      //   });
      // }

      // // 3. Check persistent storage (sessionStorage)
      // if (typeof sessionStorage !== "undefined") {
      //   try {
      //     const cacheFile = sessionStorage.getItem("pdfData");
      //     if (cacheFile) {
      //       const persistentCache = JSON.parse(cacheFile);
      //       if (persistentCache[cacheKey]) {
      //         console.log("Found PDF in persistent cache");
      //         // Add to in-memory cache
      //         this.cache.set(cacheKey, persistentCache[cacheKey]);
      //         return new Blob(
      //           [new Uint8Array(persistentCache[cacheKey].content)],
      //           { type: "application/pdf" }
      //         );
      //       }
      //     }
      //   } catch (err) {
      //     console.log("No persistent cache found or error reading it:", err);
      //   }
      // }

      // return null;
    } catch (error) {
      console.error("Error reading from cache:", error);
      return null;
    }
  }

  async writeToCache(cacheKey, data) {
    try {
      // Convert blob to array buffer
      const arrayBuffer = await data.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);

      const cacheEntry = {
        content: Array.from(uint8Array),
        timestamp: new Date().toISOString(),
      };

      // Update in-memory cache
      this.cache.set(cacheKey, cacheEntry);

      // Maintain cache size limit
      if (this.cache.size > this.maxCacheSize) {
        const oldestKey = this.cache.keys().next().value;
        this.cache.delete(oldestKey);
      }

      // Update persistent storage using sessionStorage
      if (typeof sessionStorage !== "undefined") {
        try {
          const persistentCache = {};
          this.cache.forEach((value, key) => {
            persistentCache[key] = value;
          });
          sessionStorage.setItem(
            "pdfData",
            JSON.stringify(persistentCache, null, 2),
          );
          console.log("Cache updated successfully in sessionStorage");
        } catch (err) {
          console.log("Error writing to persistent cache:", err);
        }
      }
    } catch (error) {
      console.error("Error writing to cache:", error);
    }
  }

  async fetchPdfWithCache(url, faxId, isChild = false, childId = null) {
    try {
      const cacheKey = isChild ? `${faxId}_${childId}` : faxId;

      // Try to get from cache first
      const cachedPdf = await this.readFromCache(cacheKey);
      if (isDemo && cachedPdf) {
        return cachedPdf;
      }

      // If not in cache, fetch from API
      console.log("Fetching PDF from API");
      const response = await axiosRequest.get(url, {
        responseType: "blob",
      });

      // Cache the response
      await this.writeToCache(cacheKey, response.data);
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching PDF:", error);
      throw error;
    }
  }
}

// Export singleton instance
export const pdfCacheManager = new PDFCacheManager();
